// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"404":"e07ee1ea","513":"3b861745"}[chunkId] + ".chunk.js";
};